// Phone number utility functions

// Format phone number as (XXX) XXX-XXXX
export function formatPhoneNumber(value: string): string {
  // Remove all non-digits
  const digits = value.replace(/\D/g, '');

  // Limit to 10 digits
  const trimmed = digits.slice(0, 10);

  // Format based on length
  if (trimmed.length === 0) return '';
  if (trimmed.length <= 3) return `(${trimmed}`;
  if (trimmed.length <= 6)
    return `(${trimmed.slice(0, 3)}) ${trimmed.slice(3)}`;
  return `(${trimmed.slice(0, 3)}) ${trimmed.slice(3, 6)}-${trimmed.slice(6)}`;
}

// Extract just digits from formatted phone number
export function extractDigits(value: string): string {
  return value.replace(/\D/g, '').slice(0, 10);
}

// Normalize to E.164 format for API calls
export function normalizeUsPhoneNumber(value: string): string {
  const digits = extractDigits(value);
  if (digits.length !== 10) return '';
  return `+1${digits}`;
}

// Sanitize input for initial values
export function sanitizeUsPhoneInput(value: string): string {
  // Remove +1 prefix if present
  let digits = value.replace(/\D/g, '');
  if (digits.startsWith('1') && digits.length === 11) {
    digits = digits.slice(1);
  }
  return formatPhoneNumber(digits);
}
